<script setup>
import { Head } from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import TutorProfile from '@/Components/Tutors/TutorProfile.vue'

/**
 * A tutor's profile, for a visitor.
 *
 * The page itself is only the frame: everything below the header lives in
 * TutorProfile, shared with the signed-in view at /student/tutors/{slug}. The
 * two had drifted into different layouts, so a student saw a different profile
 * from the one that convinced them to sign up.
 */
defineProps({
  tutor: { type: Object, required: true },
  availability: { type: Array, default: () => [] },
  availabilityLegend: { type: Array, default: () => [] },
  subscriptions: { type: Array, default: () => [] },
})
</script>

<template>
  <Head>
    <title>{{ tutor.name }} — Bindle tutor</title>
  </Head>

  <AppLayout>
    <!--
      The page owns its container; the profile owns everything inside it. The
      dashboard route does the same, except its layout supplies the container,
      which is the only reason the two frames differ at all.
    -->
    <div class="container-page py-8 md:py-12">
      <TutorProfile
        :tutor="tutor"
        :availability="availability"
        :availability-legend="availabilityLegend"
        :subscriptions="subscriptions"
      />
    </div>
  </AppLayout>
</template>
